<div *ngIf="loading" class="overlay">
  <div class="spinner"></div>
</div>
